module.exports = __webpack_public_path__ + "static/media/icon-tick-white.cc6eeb2d.svg";